import React, { useState } from 'react'
import convertNumbThousand from 'utils/convertNumbThousand';
interface EditableNumberProps {
    value: number
    name: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: any) => void
    max?: number
    min?: number
    prefix?: string
    suffix?: string
    inputClass?: string
}

export const EditableNumber: React.FC<EditableNumberProps> = ({
    value = 0,
    name = "",
    onChange = () => { },
    onBlur = () => { },
    max = 1000000,
    min = 0,
    prefix = "",
    suffix = "",
    inputClass = ""
}) => {
    const [edit, setEdit] = useState(false)

    const renderInput = () => {
        if (edit) {
            return (
                <input
                    type='number'
                    max={max}
                    min={min}
                    name={name}
                    id={name}
                    className={` block w-full pl-7 pr-3 sm:text-sm bg-white-700 rounded-full text-neutral-900 font-semibold min-w-[260px]
                    dark:bg-zinc-800  ${inputClass}`}
                    defaultValue={value}
                    onChange={onChange}
                    onBlur={(e) => {
                        setEdit(false);

                        let newValue = parseInt(e.currentTarget.value);

                        if (isNaN(newValue)) {
                            newValue = value; // Reset to min if not a valid number
                        } else if (newValue < min) {
                            newValue = max; // Set to max if less than min
                        } else if (newValue > max) {
                            newValue = max; // Set to max if greater than max
                        }

                        e.currentTarget.value = newValue.toString();
                        onBlur(e);
                        onChange(e);
                    }}
                    onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === "Enter") {
                            e.currentTarget.blur();
                            setEdit(false);
                        }
                    }}
                />
            )
        }

        return (
            <input
                type="text"
                name={name}
                onClick={() => setEdit(true)}
                onTouchStart={() => setEdit(true)}
                readOnly
                id={name}
                className={` block w-full pl-7 pr-3 sm:text-sm bg-white-700 rounded-full text-neutral-900 font-semibold dark:bg-zinc-800  ${inputClass}`}
                value={convertNumbThousand(parseInt(value.toString()))}
            />
        )
    }

    return (
        <>
            {prefix && (
                <div className="relative flex font-normal items-center dark:bg-custom-200/50 my-6 rounded-full w-full ">
                    <span className="absolute left-1 top-0 bottom-0 flex items-center justify-center pl-3 text-base">{prefix}</span>
                    {renderInput()}
                </div>
            )}

            {suffix && (
                <div className="relative flex font-normal items-center w-full">
                    {renderInput()}
                    <span className="absolute right-0 top-0 bottom-0 flex items-center justify-center px-8 text-base">{suffix}</span>
                </div>
            )}

            {!prefix && !suffix && (
                renderInput()
            )}
        </>
    );
}